'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/timeline/style/css.js
// module id = w3+u
// module chunks = 0